module.exports = __webpack_public_path__ + "img/tt.611b52be.svg";